import React from "react";
import Forecast from "./Forecast";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Forecast city="San Francisco" />
        <footer>
          Coded by Bee🐝 Lynn. Code on{" "}
          <a
            href="https://github.com/mayday31/final-project-weather"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
          , hosted on{" "}
          <a
            href="https://final-project-weather-7z9d.onrender.com/"
            target="_blank"
            rel="noreferrer"
          >
            Render
          </a>
          .
        </footer>
      </div>
    </div>
  );
}

export default App;
